import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BlockingLoaderProgress } from './BlockingLoaderProgress';



@Component({
    selector: 'srp-blocking-loader-dialog',
    templateUrl: './blocking-loader-dialog.component.html',
    styleUrls: ['./blocking-loader-dialog.component.scss'],
    standalone: false
})
export class BlockingLoaderDialogComponent implements OnInit, OnDestroy {
    private _destroy$: Subject<boolean> = new Subject();
    title = 'Processing';
    progress?: number = undefined;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: {
            title: string,
            showBlockingProgress$: Observable<boolean>,
            fileProgress$: Observable<BlockingLoaderProgress>,
        },
        private _dialogRef: MatDialogRef<BlockingLoaderDialogComponent>,
        private _ngZone: NgZone) {
        this.title = data.title;
    }

    ngOnInit(): void {
        this.data.showBlockingProgress$
            .pipe(takeUntil(this._destroy$))
            .subscribe(z => {
                if (!z) {
                    this._dialogRef.close(undefined);
                }
            });
        this.data.fileProgress$
            .pipe(takeUntil(this._destroy$))
            .subscribe(z => {
                this._ngZone.run(() => {
                    this.progress = z && z.inProgress ? z.percentage : undefined;
                });
            });
    }


    ngOnDestroy(): void {
        this._destroy$.next(true);
        this._destroy$.complete();
    }
}